import { Typography } from '@material-tailwind/react'
import { colors } from '@material-tailwind/react/types/generic'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'

interface TableHeaderWithSortingProps {
  title: string
  sortKey?: string
  sort?: string
  setSort?: (sort: string) => void
}

const TableHeaderWithSorting: React.FC<TableHeaderWithSortingProps> = ({ title, sortKey, sort, setSort }) => {
  const isSortable = Boolean(setSort && sortKey)
  const isDesc = sort?.startsWith('-')
  const activeSortKey = isDesc ? sort?.substring(1) : sort
  const isSorting = Boolean(isSortable && activeSortKey === sortKey)

  const toggleSorting = () => {
    if (!isSortable || !setSort || !sortKey) return
    setSort(sort === sortKey ? `-${sortKey}` : sortKey)
  }

  return (
    <th
      className={`border-b border-blue-gray-100 bg-blue-gray-500/30 dark:bg-primary-600 p-4 ${isSortable ? 'cursor-pointer' : ''}`}
      {...(isSortable
        ? {
            onClick: toggleSorting,
          }
        : {})}
    >
      <Typography variant="small" color={'primary' as colors} className="font-bold leading-none flex gap-2">
        {title}
        {isSorting && isDesc && <IoIosArrowUp data-testid="table-sort-indicator" />}
        {isSorting && !isDesc && <IoIosArrowDown data-testid="table-sort-indicator" />}
      </Typography>
    </th>
  )
}

export default TableHeaderWithSorting
